import Create from '@/plugin/notice/create'
import Component from '@/plugin/notice/Notice.vue'

let Notice = {}

Notice.install = function (Vue) {
  Vue.prototype.$notice = function (option) {
    try {
      const comp = Create(Component, option)
      if (comp && typeof comp.show === 'function') {
        comp.show()
      } else {
        console.warn('Failed to create notice component')
      }
    } catch (error) {
      console.error('Notice plugin error:', error)
      // 降级到简单的 alert
      const message = typeof option === 'string' ? option : option.message
      if (message) {
        alert(message)
      }
    }
  }
}

export default Notice
